/* eslint-disable import/prefer-default-export */
import { atom } from "jotai";
import type { Notification } from "./notification.type";

const notificationObjectList = atom<Notification[]>([]);

export const notificationObjectListAtom = atom(
    (get) => {
        return get(notificationObjectList);
    },
    (_, set, newNotificationList: Notification[]) => {
        set(notificationObjectList, newNotificationList);
    }
);
